// extracted by mini-css-extract-plugin
export default {"btnContainer":"menu-lateral-btn_btnContainer__qBaxg","icon":"menu-lateral-btn_icon__+w0gv","seta":"menu-lateral-btn_seta__ZBjhG"};